import { useEffect, useState } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "../lib/data";
import { telHref } from "../lib/phone";
import { trackEvent } from "../lib/analytics";

const WHATSAPP_MESSAGE =
  "Hello Baheti Steel Traders, I'd like a quote / more information.";

/**
 * Persistent floating Call + WhatsApp bar for mobile viewports.
 * - Fixed to the bottom of the screen (safe-area aware) below < md breakpoint.
 * - Hidden on desktop where the top navbar already offers a click-to-call CTA.
 * - Slides in on first scroll to avoid competing with the hero on initial load.
 */
export const MobileContactCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const digits = COMPANY.phone.replace(/\D/g, "");
  const waHref = `https://wa.me/${digits}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div
      data-testid="mobile-contact-cta"
      className={`fixed inset-x-3 bottom-3 z-40 flex gap-2 transition-all duration-500 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      aria-hidden={!visible}
    >
      <a
        href={telHref(COMPANY.phone)}
        onClick={() =>
          trackEvent("phone_click", {
            source: "mobile_floating_cta",
            phone_number: COMPANY.phone,
          })
        }
        data-testid="mobile-cta-call"
        className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#1c1c1e] px-4 py-3.5 text-[13px] font-semibold uppercase tracking-[0.16em] text-white shadow-[0_16px_40px_-12px_rgba(28,28,30,0.5)] transition-transform active:scale-95"
      >
        <Phone size={16} />
        Call now
      </a>
      <a
        href={waHref}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() =>
          trackEvent("whatsapp_click", {
            source: "mobile_floating_cta",
            phone_number: COMPANY.phone,
          })
        }
        data-testid="mobile-cta-whatsapp"
        className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#25D366] px-4 py-3.5 text-[13px] font-semibold uppercase tracking-[0.16em] text-white shadow-[0_16px_40px_-12px_rgba(37,211,102,0.55)] transition-transform active:scale-95"
      >
        <MessageCircle size={16} />
        WhatsApp
      </a>
    </div>
  );
};

export default MobileContactCTA;
